// CallToAction.tsx
export function CallToAction() {
  return (
    <section className="py-32 px-6 bg-black text-white" data-lenis-scroll>
      <div className="max-w-4xl mx-auto text-center space-y-8">
        <h2 className="text-4xl font-semibold tracking-tight">
          Upgrade Your Customer Experience
        </h2>

        {/* <button className="px-8 py-4 bg-white text-black rounded-full text-sm">
          Get Started
        </button> */}
      </div>
    </section>
  );
}
